import * as React from "react";
import { connect } from "react-redux";

import * as actions from "../../actions";
import {
  Dropdown as DropdownComponent,
  DropdownProps as DropdownComponentProps,
} from "../../components/Dropdown/Dropdown";
import { StoreState } from "../../reducers";
import { getWidgetFormErrors } from "../../reducers/methods";

// Supplied by this container in render, so they are not part of the contract a
// caller satisfies. `connect` subtracts the redux-injected props on its own;
// these two are injected by hand, so only an explicit Omit can say so.
type InjectedByContainer = "onFormError" | "onFormChange";

interface DropdownProps
  extends Omit<DropdownComponentProps, InjectedByContainer> {
  clearWidgetFormError: typeof actions.clearWidgetFormError;
  formErrors: {
    [key: string]: { [index: string]: any };
  };
  setWidgetFormError: typeof actions.setWidgetFormError;
  setUserInput: typeof actions.setUserInput;
}

class Dropdown extends React.Component<DropdownProps> {
  render() {
    const { setWidgetFormError, setUserInput } = this.props;

    return (
      <DropdownComponent
        {...this.props}
        onFormError={setWidgetFormError}
        onFormChange={setUserInput}
      />
    );
  }
}

const mapStateToProps = (state: StoreState) => ({
  formErrors: getWidgetFormErrors(state),
});

export default connect(mapStateToProps, {
  clearWidgetFormError: actions.clearWidgetFormError,
  setWidgetFormError: actions.setWidgetFormError,
  setUserInput: actions.setUserInput,
})(Dropdown);
